import { Stack } from '@mui/material';
import { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { useModal } from '@ebay/nice-modal-react';
import { Button, Markdown, Typography, SizingMultiplier } from '@ocx/ui';
import { logInDev } from '@ocx/utils';

import { ConfirmationActionSheetProps } from './confirmation-action-sheet.types';
import { ModalDrawer } from '../components';
import { buttonTextMessages } from '../../../modules/localization/button-text.messages';

export const ConfirmationActionSheetController = (props: ConfirmationActionSheetProps) => {
  const intl = useIntl();
  const {
    title,
    description,
    confirmButtonText = intl.formatMessage(buttonTextMessages['button-text:confirm']),
    cancelButtonText = intl.formatMessage(buttonTextMessages['button-text:cancel']),
    cancelOnClickOutsideDisabled = false,
    onConfirm,
    onCancel,
    onClosed,
  } = props;

  const { visible, hide, remove } = useModal();

  const handleExited = useCallback(() => {
    onClosed?.();
    remove();
  }, [remove, onClosed]);

  const handleConfirm = useCallback(() => {
    onConfirm();
    hide().catch(logInDev);
  }, [hide, onConfirm]);

  const handleCancel = useCallback(() => {
    onCancel?.();
    hide().catch(logInDev);
  }, [hide, onCancel]);

  return (
    <ModalDrawer
      open={visible}
      onClose={cancelOnClickOutsideDisabled ? undefined : handleCancel}
      onExited={handleExited}>
      <Stack spacing={SizingMultiplier.lg} p={SizingMultiplier.lg} pt={SizingMultiplier.xl}>
        <Stack spacing={SizingMultiplier.md}>
          <Typography variant="h5" component="h1">
            {title}
          </Typography>
          {description && <Markdown>{description}</Markdown>}
        </Stack>
        <Stack spacing={SizingMultiplier.sm}>
          <Button onClick={handleConfirm}>{confirmButtonText}</Button>
          <Button onClick={handleCancel} variant="text">
            {cancelButtonText}
          </Button>
        </Stack>
      </Stack>
    </ModalDrawer>
  );
};
